import * as React from 'react';
import BFSelect, { SelectAlignment } from '../components/Select';
import { PropertyType } from '@beatflyer/shaders-lib';
import { PropertyNumberInput } from './CustomPropertyNumberInput';
import {
  CustomProperty,
  getPropertyPositionWithValue,
  getPropertyValueWithPosition
} from '../data/CustomProperty';
import { ColorPicker } from './components/ColorPicker';

interface Props {
  name: string;
  id: string;
  data: CustomProperty;
  value: any;
  onChange: (property: string, value: any) => void;
}

export class CustomPropertyRow extends React.Component<Props> {
  format: string;
  input = React.createRef<HTMLDivElement>();

  didChange = (value: any) => {
    this.props.onChange(this.props.id, value);
  };

  componentDidMount() {
    this.input.current?.addEventListener('mousedown', this.onMouseDown);
  }
  componentWillUnmount() {
    this.input.current?.removeEventListener('mousedown', this.onMouseDown);
  }
  onMouseDown = (e: MouseEvent) => {
    this.updateDial(e);
    window.addEventListener('mousemove', this.updateDial);
    window.addEventListener('mouseup', this.onMouseUp);
  };
  onMouseUp = (e: MouseEvent) => {
    window.removeEventListener('mousemove', this.updateDial);
    window.removeEventListener('mouseup', this.onMouseUp);
  };
  updateDial = (e: MouseEvent) => {
    if (!this.input.current) {
      return;
    }
    const inputRect = this.input.current.getBoundingClientRect();
    const half = 29 * 0.5;
    const x = e.clientX - inputRect.left - half;
    const y = e.clientY - inputRect.top - half;
    let angle = (Math.atan2(x, -y) * 180) / Math.PI;
    if (e.shiftKey) {
      angle = Math.round(angle / 45) * 45;
    }
    this.didChange(angle);
  };

  numericValueDidChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const position = parseFloat(event.target.value);
    const value = getPropertyValueWithPosition(this.props.data, position);
    // console.log( 'position: ' + position + ' value: ' + value );
    this.didChange(value);
  };

  checkboxDidChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.didChange(event.target.checked);
  };

  selectDidChange = (value: any) => {
    this.didChange(value);
  };

  didChangeValueManually = (newValue: number) => {
    this.didChange(newValue);
  };

  render() {
    const { value } = this.props;
    const { type, minValue, maxValue } = this.props.data;
    let input = null;
    switch (type) {
      case PropertyType.NUMBER:
      case PropertyType.INT:
        const position = getPropertyPositionWithValue(this.props.data, value);
        // console.log( 'value: ' + this.props.value + ' position: ' + position );
        input = (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <input
              type="range"
              min={0}
              max={1}
              step={0.0001}
              value={position}
              onChange={this.numericValueDidChange}
              style={{ flexGrow: 1 }}
            />
            <PropertyNumberInput
              value={value}
              minValue={minValue || 0}
              maxValue={maxValue || 1}
              type={type}
              onChange={this.didChangeValueManually}
            />
          </div>
        );
        break;

      case PropertyType.DIRECTION:
        input = (
          <div>
            <div className="input direction" ref={this.input}>
              <div
                className="dial"
                style={{
                  transform: 'rotate(' + value + 'deg)'
                }}
              />
            </div>
            <PropertyNumberInput
              value={value}
              minValue={-180}
              maxValue={180}
              type={type}
              onChange={this.didChangeValueManually}
            />
          </div>
        );
        break;

      case PropertyType.BOOLEAN:
        input = (
          <input
            type="checkbox"
            value={value}
            defaultChecked={value}
            onChange={this.checkboxDidChange}
          />
        );
        break;
      case PropertyType.COLOR:
      case PropertyType.COLOR_WITH_ALPHA:
        input = (
          <ColorPicker
            color={value}
            onChange={this.didChange}
            hideAlpha={type === PropertyType.COLOR}
            compact={true}
          />
        );
        break;

      case PropertyType.SELECT:
        input = (
          <BFSelect
            value={value}
            formatValue={this.props.data.formatValue}
            onChange={this.selectDidChange}
            options={this.props.data.options}
            shouldBeDismissedOnSelect={this.props.data.dismissOnSelect}
            alignment={SelectAlignment.RIGHT}
          />
        );
        break;

      default:
        console.log('Could not build UI for input type: ' + type);
        return null;
    }
    return (
      <div
        className="custom-property"
        style={{
          lineHeight: type === PropertyType.DIRECTION ? '30px' : ''
        }}
      >
        <label>{this.props.name}</label>
        {input}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/CustomPropertyRow.tsx